import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import bem from 'utils/bem';
import Text from 'components/Text';
import Page from '../Page';
import ConsultationsFAQ from './ConsultationsFAQ';
import ShopFAQ from './ShopFAQ';
import GiveCertWidget from 'components/GiveCertWidget';
import BuyConsultationWidget from 'components/BuyConsultationWidget';
import Model from '../../../model';

import './index.sass';

const { block, el } = bem('faq');

const FAQ = () => {

    useEffect(() => {
        Model.faq.getFAQ();
    }, []);

    return (
        <Page className={block()} title={'Вопрос — ответ'}>
            <div className={el('content')}>
                <div className={el('consultations-faq')}>
                    <div className={el('faq-title')}>
                        <Text serif>Частые вопросы по консультациям</Text>
                    </div>
                    <ConsultationsFAQ />
                </div>
                <div className={el('shop-faq')}>
                    <div className={el('faq-title')}>
                        <Text serif>Частые вопросы по магазину</Text>
                    </div>
                    <ShopFAQ />
                </div>
            </div>
            <div className={el('right-sidebar')}>
                <GiveCertWidget />
                <BuyConsultationWidget />
            </div>
        </Page>
    )
}

export default observer(FAQ);
